<script>
import SolutionCard from 'ee/vue_shared/security_reports/components/solution_card_graphql.vue';
import MergeRequestNote from 'ee/vue_shared/security_reports/components/merge_request_note_graphql.vue';
import VulnerabilityDetailsGraphql from 'ee/security_dashboard/components/shared/vulnerability_details_graphql/index.vue';
import IssueNote from 'ee/vue_shared/security_reports/components/issue_note_graphql.vue';

export default {
  name: 'VulnerabilityFindingModalDetails',
  components: {
    IssueNote,
    MergeRequestNote,
    SolutionCard,
    VulnerabilityDetailsGraphql,
  },
  props: {
    vulnerability: {
      type: Object,
      required: true,
    },
  },
  computed: {
    remediation() {
      return this.vulnerability?.remediations?.[0];
    },
    mergeRequest() {
      return this.vulnerability?.vulnerability?.mergeRequest;
    },
    issueLinks() {
      return this.vulnerability?.issueLinks?.nodes || [];
    },
  },
};
</script>

<template>
  <div v-if="vulnerability">
    <vulnerability-details-graphql
      v-bind="vulnerability"
      @redirectToCodeFlowTab="$emit('redirectToCodeFlowTab')"
    />

    <solution-card
      :solution-html="vulnerability.solutionHtml"
      :solution="vulnerability.solution"
      :remediation="remediation"
      :merge-request="mergeRequest"
    />

    <issue-note :issue-links="issueLinks" :project="vulnerability.project" />
    <merge-request-note :merge-request="mergeRequest" :project="vulnerability.project" />
  </div>
</template>
